import { all, put, takeLatest } from "redux-saga/effects";
import {
  componentKey,
  setCloseCreateDocumentDialog,
  setDocumentListData,
} from "./documentsSlice";
import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import DocumentService from "../../services/DocumentService";

export const { getDocumentList, createDocument, updateDocument, deleteDocument } =
  {
    getDocumentList: (payload) => {
      return {
        type: "DOCUMENTS/GET_DOCUMENT_LIST",
        payload,
      };
    },
    createDocument: (payload) => {
      return {
        type: "DOCUMENTS/CREATE_DOCUMENT",
        payload,
      };
    },
    updateDocument: (payload) => {
      return {
        type: "DOCUMENTS/UPDATE_DOCUMENT",
        payload,
      };
    },
    deleteDocument: (payload) => {
      return {
        type: "DOCUMENTS/DELETE_DOCUMENT",
        payload,
      };
    },
  };

// GET DOCUMENT LIST ASYNC
function* getDocumentListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield DocumentService.getDocumentList(action?.payload);
    const { status } = response;
    if (status) {
      yield put(setDocumentListData(response?.data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setDocumentListData({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// CREATE DOCUMENT ASYNC
function* createDocumentAsync(action) {
  try {
    yield put(showLoader());
    const response = yield DocumentService.createDocument(action?.payload);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: message || "Document created successfully",
        status: "success",
      });
      yield put(setCloseCreateDocumentDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseCreateDocumentDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// UPDATE DOCUMENT ASYNC
function* updateDocumentAsync(action) {
  const { id, apiPayload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield DocumentService.updateDocument(id, apiPayload);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: message || "Document updated successfully",
        status: "success",
      });
      yield put(setCloseCreateDocumentDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseCreateDocumentDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE DOCUMENT ASYNC
function* deleteDocumentAsync(action) {
  const { id, listPayload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield DocumentService.deleteDocument(id);
    const { status } = response;
    if (status) {
      const { message } = response?.data;
      eventEHRCustomToastMessage({
        title: message || "Document deleted successfully",
        status: "success",
      });
      // Refresh the document list after successful deletion
      yield put(getDocumentList(listPayload));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([takeLatest(getDocumentList().type, getDocumentListAsync)]);
  yield all([takeLatest(createDocument().type, createDocumentAsync)]);
  yield all([takeLatest(updateDocument().type, updateDocumentAsync)]);
  yield all([takeLatest(deleteDocument().type, deleteDocumentAsync)]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
